import gql from 'graphql-tag'

export const meetingSpaceQuery = gql`
    query getMeetingSpace($eventId: EventID!, $spaceFilters: MeetingSpaceFilter) {
        event(id: $eventId) {
            meetingSpaces(first: 1, filters: $spaceFilters) {
                edges {
                    node {
                        id
                        parent {
                            id
                            image
                            name
                            slug
                            published
                            enableChat
                            helpContent
                            helpContentType
                        }
                    }
                }
            }
        }
    }
`

const meetingFragment = gql`
    fragment meetingFragment on MeetingType {
        id
        title
        capacity
        capacityLeft
        startsAt
        endsAt
        enableBreakoutRooms
        closed
        isWalkInMeeting
        description
        programItem {
            id
            name
        }
        hosts {
            totalCount
        }
    }
`
export const meetingsQuery = gql`
    query getMeetings(
            $eventId: EventID!,
            $search: String,
            $first: Int,
            $after: ID,
            $sort: MeetingOrder,
            $date: Date,
            $spaceFilters: MeetingSpaceFilter,
            $meetingFilters: MeetingFilter
        ) {
        event(id: $eventId) {
            meetingSpaces(first: 1, filters: $spaceFilters) {
                edges {
                    node {
                        meetings(search: $search, orderBy: $sort, first: $first, after: $after, date: $date, filters: $meetingFilters) {
                            edges {
                                node {
                                    ...meetingFragment
                                }
                            }
                            pageInfo {
                                hasPreviousPage
                                hasNextPage
                                endCursor
                            }
                            totalCount
                        }
                    }
                }
            }
        }
    }
    ${meetingFragment}
`

const participantFragment = gql`
    fragment participant on MeetingUserType {
        id
        user {
            id
            mugshot
            firstName
            lastName
            jobtitle
            company
            email
            hasLoggedOn
        }
        role
    }
`

export const participantsQuery = gql`
    query getParticipants(
            $eventId: EventID!,
            $spaceFilters: MeetingSpaceFilter,
            $meetingFilters: MeetingFilter,
            $first: Int,
            $after: ID,
        ) {
        event(id: $eventId) {
            meetingSpaces(first: 1, filters: $spaceFilters) {
                edges {
                    node {
                        meetings(filters: $meetingFilters) {
                            edges {
                                node {
                                    participants(first: $first, after: $after) {
                                        edges {
                                            node {
                                                ...participant
                                            }
                                        }
                                        pageInfo {
                                            hasPreviousPage
                                            hasNextPage
                                            endCursor
                                        }
                                        totalCount
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    ${participantFragment}
`

export const hostsQuery = gql`
    query getHosts(
            $eventId: EventID!,
            $spaceFilters: MeetingSpaceFilter,
            $meetingFilters: MeetingFilter,
            $first: Int,
            $after: ID,
        ) {
        event(id: $eventId) {
            meetingSpaces(first: 1, filters: $spaceFilters) {
                edges {
                    node {
                        meetings(filters: $meetingFilters) {
                            edges {
                                node {
                                    hosts(first: $first, after: $after) {
                                        edges {
                                            node {
                                                ...participant
                                            }
                                        }
                                        pageInfo {
                                            hasPreviousPage
                                            hasNextPage
                                            endCursor
                                        }
                                        totalCount
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    ${participantFragment}
`
